import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content"]

  show() {
    this.contentTargets.forEach(el => {
      el.style.opacity = "1"
    })
  }

  hide() {
    this.contentTargets.forEach(el => {
      el.style.opacity = "0"
    })
  }
}
